import dayjs from 'dayjs'

export const formatSurveyDate = (date = '') => dayjs(date).format('MMM DD, YYYY')
